import { Col, Row } from "react-bootstrap";
import utilstopAppointmentLogo from "../../assets/images/EzietPro Logo.svg";
import create_profile_icon from "../../assets/images/create_profile_icon.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ProfileSetup = () => {
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
console.log(initialValues.phone ,"initialValues.phone ")
// Inside your ProfileSetup component
const [fullNumber, setFullNumber] = useState(initialValues.phone || "");
const [phoneNumber, setPhoneNumber] = useState(""); // phone without country code
const [countryCode, setCountryCode] = useState("");
const [errorMessage, setErrorMessage] = useState("");
const formikRef = useRef();
// Function to handle phone input changes
const numberOnChange = (value, country, formattedValue) => {
  console.log(value,"value")
  setFullNumber(value);

    const countryMinLengths = { in: 10, ae: 9 };
    const minLength = countryMinLengths[country.countryCode] || 10;

    const phoneWithoutCode = value.replace(country.dialCode, "").trim();

  if (phoneWithoutCode.length >= minLength) {
    setPhoneNumber(phoneWithoutCode);
    setCountryCode(country.dialCode);
    setErrorMessage("");
  } else {
    setErrorMessage(
      `Please enter a valid ${country.name} phone number (minimum ${minLength} digits)`
    );
  }
  formikRef.current.setFieldValue(
    "phone",
    `${country.dialCode}${phoneWithoutCode}`
  );
};
useEffect(() => {
  setFullNumber(initialValues.phone || "");
}, [initialValues.phone]);
  useEffect(() => {
    const phoneNumber = searchParams.get("phone_number");
    const email = searchParams.get("email");

    if (!phoneNumber) {
      setIsEmail(true);
    } else {
      setIsEmail(false);
    }
    setInitialValues({
      name: "",
      email: email || "",
      password: "",
      phone: phoneNumber || "",
    });
  }, [searchParams]);

  const validationSchema = Yup.object({
    name: Yup.string().min(2, "Too Short!").required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    password: isEmail
      ? Yup.string()
          .min(6, "Password minimum at least 6 characters")
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/,
            "Password must contain at least one uppercase letter, one lowercase letter and one number"
          )
          .required("Password is required")
      : Yup.string(),
  });

  // console.log("validationSchema----", validationSchema);

  // const sumbitProfileInfo = async (values) => {
  //   try {
  //     // console.log("sumbitProfileInfo------", values);
  //     const res = await apicall.post(values, "ezp_profile_register");
  //     // console.log("res------", res);
  //     // navigate("/dashboard");
  //     navigate("/setup");
  //   } catch (e) {
  //     console.log("err--sumbitProfileInfo---", e);
  //   }
  // };
const sumbitProfileInfo = async (values) => {
  try {
    // const formattedPhone = `${countryCode}${phoneNumber}`;
    const formattedPhone = !isEmail
      ? initialValues.phone
      : `${countryCode}${phoneNumber}`;

    if (!formattedPhone) {
      setErrorMessage("Phone number is required");
      return;
    }

    const payload = {
      ...values,
      phone: formattedPhone,
    };

    const res = await apicall.post(payload, "ezp_profile_register");
console.log(res,"res")
    //  backend handles validation
    if (!res?.success) {
      setErrorMessage(res.message);
      return;
    }

    navigate("/setup");

  } catch (e) {
  console.log("Submit error:", e);

  const backendMessage =
    e?.response?.data?.message ||  // axios
    e?.data?.message ||            // custom wrapper
    e?.message;

  setErrorMessage(
    backendMessage || "Something went wrong. Please try again."
  );
}
};
  // console.log("phone_number---------", phone);

  return (
    <div>
      <header>
        <nav className="p-2 background-color-white">
          <img
            src={utilstopAppointmentLogo}
            alt={"vendor Name"}
            style={{ width: "150px", height: "50px" }}
          />
        </nav>
      </header>
      <Row className="profile_bg_color">
        <Col md={8} className="flex_center">
          <div className="left_row">
            <h1 className="title_head">
              Join Us and Unlock Endless Possibilities!
            </h1>
            <h6 className="title_sub_head">
              Lorem ipsum dolor sit amet consectetur. In in vel eget
              pellentesque ultrices ipsum. Diam tempor mauris viverra metus
              gravida lacinia enim sodales. Fusce proin ut fringilla aliquam
              cras. Rutrum tincidunt scelerisque purus quam etiam ullamcorper
              placerat pharetra.
            </h6>
          </div>
        </Col>
        <Col md={4} className="background-color-red">
          <div className="register_form">
            <div>
              <img
                src={create_profile_icon}
                alt={"create_profile_icon"}
                style={{ width: "30px", height: "auto" }}
              />
              <h1 className="title_bold">Register for free</h1>
            </div>

            <Formik
             innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                console.log("Form Data:", values);
                // alert("Form Submitted!");
                sumbitProfileInfo(values);
                // resetForm();
              }}
            >
              {() => (
                <Form>
                  <div className="mb-2">
                    <div className="register_label">Name</div>
                    <Field type="text" name="name" />
                    <ErrorMessage
                      name="name"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-2">
                    <div className="register_label">Email</div>
                    <Field type="email" name="email" readOnly={isEmail} />
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>

                  {isEmail && (
                    <div className="mb-2">
                      <div className="register_label">Password</div>

                      <Field name="password">
                        {({ field, form }) => {
                          const realPassword = field.value || "";

                          return (
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="text"
                                value={
                                  showPassword
                                    ? realPassword
                                    : "*".repeat(realPassword.length)
                                }
                                onChange={(e) => {
                                  const inputValue = e.target.value;

                                  if (!showPassword) {
                                    if (
                                      inputValue.length > realPassword.length
                                    ) {
                                      const newChar =
                                        inputValue[inputValue.length - 1];
                                      form.setFieldValue(
                                        "password",
                                        realPassword + newChar
                                      );
                                    } else {
                                      form.setFieldValue(
                                        "password",
                                        realPassword.slice(0, inputValue.length)
                                      );
                                    }
                                  } else {
                                    form.setFieldValue("password", inputValue);
                                  }
                                }}
                                style={{ width: "100%", paddingRight: "40px" }}
                              />

                              <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          );
                        }}
                      </Field>

                      <ErrorMessage
                        name="password"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  )}

                  {/* Phone */}
                  <div className="mb-2">
                    <div className="register_label">Phone</div>

  <PhoneInput
    onlyCountries={["in", "ae"]}
    country={"in"}
    value={fullNumber}
    onChange={numberOnChange}
    inputStyle={{ width: "100%" }}
    disabled={!isEmail} // editable only if registered via email
  />

                    {errorMessage && (
                      <div style={{ color: "red" }}>{errorMessage}</div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn-danger w-100 border-radius-20 btn-custom-danger border-none p-2 mt-3"
                  >
                    {loader ? (
                      <Loader style={{ width: 40, height: 20 }} />
                    ) : (
                      "Register"
                    )}
                  </button>
                  <div>
                    <p className="text-center mt-3">
                      Already have an account?{" "}
                      <a href="/" className="text-danger">
                        Login
                      </a>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProfileSetup;
